import SvgIcon from "@mui/material/SvgIcon";

export const WatchListIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 55 55" {...props}>
      <g strokeWidth="1" stroke="currentColor">
        <path
          d="M54.836,44.241c-3.514-5.367-8.206-8.395-13.26-8.591c-0.267-0.032-0.538-0.052-0.813-0.052
		c-0.489,0-0.965,0.053-1.425,0.149c-4.597,0.592-8.832,3.552-12.068,8.494l-0.466,0.711l0.359,0.548
		c3.635,5.552,8.529,8.609,13.783,8.609c5.254,0,10.148-3.058,13.783-8.609l0.466-0.711L54.836,44.241z M45.673,42.507
		c0,2.707-2.202,4.909-4.909,4.909s-4.909-2.202-4.909-4.909c0-2.345,1.655-4.305,3.856-4.789c0.445-0.053,0.892-0.087,1.343-0.087
		c0.02,0,0.04,0.002,0.06,0.002C43.655,37.816,45.673,39.919,45.673,42.507z M40.946,52.109c-4.387,0-8.537-2.537-11.743-7.161
		c1.559-2.287,3.348-4.069,5.281-5.305c-0.4,0.874-0.629,1.842-0.629,2.864c0,3.81,3.1,6.909,6.909,6.909s6.909-3.1,6.909-6.909
		c0-1.216-0.318-2.358-0.872-3.352c2.204,1.207,4.242,3.107,5.996,5.638C49.577,49.516,45.383,52.109,40.946,52.109z"
        />
        <path d="M27,12.598c-0.552,0-1,0.447-1,1s0.448,1,1,1h18c0.552,0,1-0.447,1-1s-0.448-1-1-1H27z" />
        <path d="M45,28.598c0.552,0,1-0.447,1-1s-0.448-1-1-1H27c-0.552,0-1,0.447-1,1s0.448,1,1,1H45z" />
        <path
          d="M20.58,7.839c-0.419-0.36-1.05-0.313-1.41,0.108l-6.248,7.288L9.1,12.369c-0.442-0.33-1.069-0.242-1.4,0.2
		c-0.332,0.441-0.242,1.068,0.2,1.399l4.571,3.429c0.18,0.135,0.39,0.2,0.6,0.2c0.283,0,0.563-0.119,0.76-0.35l6.857-8
		C21.047,8.829,20.999,8.198,20.58,7.839z"
        />
        <path
          d="M20.58,21.839c-0.419-0.36-1.05-0.313-1.41,0.108l-6.248,7.288L9.1,26.369c-0.442-0.331-1.069-0.241-1.4,0.2
		c-0.332,0.441-0.242,1.068,0.2,1.399l4.571,3.429c0.18,0.135,0.39,0.2,0.6,0.2c0.283,0,0.563-0.119,0.76-0.35l6.857-8
		C21.047,22.829,20.999,22.198,20.58,21.839z"
        />
        <path
          d="M19.169,36.947l-6.248,7.287L9.1,41.368c-0.442-0.331-1.069-0.241-1.4,0.2c-0.332,0.441-0.242,1.068,0.2,1.399l4.571,3.429
		c0.18,0.135,0.39,0.2,0.6,0.2c0.283,0,0.563-0.119,0.76-0.35l6.857-7.999c0.359-0.419,0.311-1.05-0.108-1.409
		C20.161,36.479,19.53,36.527,19.169,36.947z"
        />
        <path
          d="M23,52.598H12.176C6.565,52.598,2,48.033,2,42.422V12.773C2,7.162,6.565,2.598,12.176,2.598h29.648
		C47.435,2.598,52,7.162,52,12.773v21.824c0,0.553,0.448,1,1,1s1-0.447,1-1V12.773C54,6.06,48.538,0.598,41.824,0.598H12.176
		C5.462,0.598,0,6.06,0,12.773v29.648c0,6.714,5.462,12.176,12.176,12.176H23c0.552,0,1-0.447,1-1S23.552,52.598,23,52.598z"
        />
      </g>
    </SvgIcon>
  );
};
